import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceBusinessRegistrationCertificateDetail } from 'modules/suppliers/types';

// export type BusinessRegistrationCertificateDetail =
//   typeof schemas.BusinessRegistrationDetailFromKios._type;
export type BusinessRegistrationCertificateDetail = ReplaceBusinessRegistrationCertificateDetail;

interface UseGetBusinessRegistrationCertificateDetailsProps {
  supplierProfileOperationCode?: string;
  customerOperationCode?: string;
  businessRegistrationOperationCode?: string;
}

const useGetBusinessRegistrationCertificateDetails = (
  props: UseGetBusinessRegistrationCertificateDetailsProps
) => {
  const { supplierProfileOperationCode, customerOperationCode, businessRegistrationOperationCode } =
    props;
  const service = useService();

  return useQuery({
    queryKey: [
      'businessRegistrationCertificateDetails',
      customerOperationCode,
      supplierProfileOperationCode,
    ],
    queryFn: async () => {
      try {
        if (
          !service ||
          !customerOperationCode ||
          !supplierProfileOperationCode ||
          !businessRegistrationOperationCode
        ) {
          return null;
        }

        const res: BusinessRegistrationCertificateDetail =
          await service.SupplierProfileController_getBusinessRegistrationDetail({
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
              businessRegistrationOperationCode,
            },
          });

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useGetBusinessRegistrationCertificateDetails;
